import Permissions from "../../models/Permissions";

const Exportacao = () => import("./index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

const meta = {
  requiresAuth: true,
  requiresCompany: true,
  showInMenu: true,
  label: "Exportar XMLs",
  icon: "fa fa-download",
  group: "Utilitários",
  permissions,
};

export default [
  {
    path: "/export",
    name: "Export",
    component: Exportacao,
    meta,
  },
];
